import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import AboutMain from "../images/about/about-main.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";
import Pickjetski from "../components/Pickjetskis";
import Jetskibanner from "../components/jetskibanner";

import { Helmet } from "react-helmet";

function Airport() {
  return (
    <>
      <Helmet>
        <title>Jetski Booking - Price Is Right ATV</title>

        <meta
          name="description"
          content="Book an exciting jet ski adventure with Price Is Right ATV in Leeward Palms, Turks & Caicos Islands. Experience the thrill of riding crystal-clear waters and create unforgettable island memories!"
        />
       
        {/* Add more meta tags as needed */}
      </Helmet>

      <section className="about-page" style={{ position: 'relative', zIndex: 400 }}>
        <HeroPages name="Jetski Booking" />

{/* 
        <div style={{backgroundColor:'grey', textAlign:'center', padding:'10px'}}>
            <h2 style={{textAlign:'center', color:'white'}}>Book Airport Transfer</h2>
            
              <p style={{color:'gold', textAlign:'center', fontSize:'13px', paddingTop:'5px'}}>Sleek Investments Car Rental offers reliable airport transfer services across Jamaica, including Norman Manley International Airport in Kingston, Ian Fleming International Airport in Boscobel, and Sangster International Airport in Montego Bay. Whether you're arriving at Montego Bay Airport, St Mary Airport, or St Ann's Bay, our airport transportation ensures a smooth and comfortable journey to your destination. Trust our professional drivers for seamless transfers, making your travel experience in Jamaica stress-free and enjoyable.</p> 
           
          </div>
          */}

        <div style={{marginTop:'30px'}} >

      <Pickjetski/>
 <Jetskibanner/>

          {/*   <PlanTrip /> */}
         
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>For more information, we can be contact at</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3 style={{color:'gold'}}> +1649 3413819</h3> 
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Airport;
